import { ECalendarEventType } from 'src/components/Calendar/Calendar.interface';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import {
  Caption,
  EventNameWrapper,
  OverridePill,
} from 'src/features/locations/calendarLocationGroupPage/modules/CalendarView/CalendarView.styled';
import { lang } from 'src/utils';

import { isEventSelected } from './EventContent.helper';
import { EventContentProps } from './EventContent.interface';

export const EventContent = (props: EventContentProps) => {
  const { event, selectedEvent } = props;

  return (
    <>
      <EventNameWrapper
        data-testid={`${event.title}-${
          event.extendedProps.scheduleId ?? event.extendedProps.assemblyId
        }`}
        $isSelected={isEventSelected(event, selectedEvent)}
        $isDefaultAssembly={
          event.extendedProps.eventType === ECalendarEventType.defaultAssembly
        }>
        <CustomTooltip
          width={500}
          placement="bottom"
          title={event?.title}
          skipValidateOverflow={false}
          overflowLineNumber={1}>
          <Caption>{event?.title}</Caption>
        </CustomTooltip>

        {event.extendedProps?.hasOverrides && (
          <OverridePill>{lang.ownerOperatorOverridePill}</OverridePill>
        )}
      </EventNameWrapper>
    </>
  );
};
